import React, { useState, useEffect } from 'react';
export const FITBIT_API_SEP = "---"


function App() {
  
  const [queryParams, setQueryParams] = useState(null);
  const [hasError, setHasError] = useState(false);
  const [message, setMessage] = useState(() => "")
  const [isProcessing, setIsProcessing] = useState(true);


const processRequest = async () => {

  setIsProcessing(true)

   const hash = window.location.search;
   const searchParams = new URLSearchParams(hash);
   const params = {};
   for (let [key, value] of searchParams.entries()) {
        params[key] = value;
      }

    // Extracts the code
    let code = params.code;

    console.log(code)
    
    if(code === undefined)
    {
      setHasError(true);
      setMessage("No code was received.");
      setIsProcessing(false);
      return
    }

    // Removes trailing of code
    code = code.replace("#_=_","");

    let response = await fetch(`/.netlify/functions/requestFitbitToken`, {
        method: "POST",
        body: JSON.stringify({ code: code })
    });

    let data;
    try {
      data = await response.json();
    } catch (e) {
      data = null;
    }

    if(!response.ok || !data)
    {
      setHasError(true);
      setMessage(
        (data && (data.error || data.message)) ||
        `Token request failed (status ${response.status})`
      );
      setIsProcessing(false);

      return
    }


    // Checks if the data has the available 
    if(["access_token", "refresh_token", "user_id"].some(k => !(k in data)))
    {
      setHasError(true);
      setMessage("The token request does not have all the necessary fields");
      setIsProcessing(false);

      return
    }

    setQueryParams(data)
    setIsProcessing(false);




}


  useEffect(() => {    
    processRequest();
        
  }, []);

  // Function to copy value to clipboard
  const copyToClipboard = (name, value) => {
    navigator.clipboard.writeText(value);
    setMessage(`Copied ${name} to clipboard`)
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <h1>Response Values</h1>

      {isProcessing ? (
        <div style={{ marginTop: "50px" }}>
          <div
            style={{
              width: "50px",
              height: "50px",
              border: "6px solid #f3f3f3",
              borderTop: "6px solid #3498db",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto",
            }}
          />
          <p>Processing...</p>
        </div>
      ) : hasError ? (
        <div style={{ marginTop: "50px", color: "red" }}>
          <h3>Error</h3>
          <p>{message}</p>
        </div>
      ) : queryParams ? (
        <>
          <button onClick={() => copyToClipboard("All Values", queryParams['access_token'] + FITBIT_API_SEP + queryParams['refresh_token']+ FITBIT_API_SEP + queryParams['user_id'])}>Copy All Values</button>
          <div style={{ marginBottom: "50px" }}>
            <h4>Access Token</h4>
            <div style={{ width: "80%", marginLeft: "10%", marginRight: "10%", overflowWrap: "anywhere", marginBottom: "10px" }}>
              {queryParams['access_token']}
            </div>
            <button onClick={() => copyToClipboard("Access Token", queryParams['access_token'])}>Copy</button>
          </div>
          <div style={{ marginBottom: "50px" }}>
            <h4>Refresh Token</h4>
            <div style={{ width: "80%", marginLeft: "10%", marginRight: "10%", overflowWrap: "anywhere", marginBottom: "10px" }}>
              {queryParams['refresh_token']}
            </div>
            <button onClick={() => copyToClipboard("Access Token", queryParams['refresh_token'])}>Copy</button>
          </div>
          <div style={{ marginBottom: "50px" }}>
            <h4>Request ID</h4>
            <div style={{ width: "40%", marginLeft: "30%", marginRight: "30%", overflowWrap: "anywhere", marginBottom: "10px" }}>
              {queryParams['user_id']}
            </div>
            <button onClick={() => copyToClipboard("Request ID", queryParams['user_id'])}>Copy</button>
          </div>

          <div>
            {message}
          </div>

        </>
      ) : (
        <p>No query parameters found.</p>
      )}
    </div>
  );
}

export default App;
